import moment from "moment";

// DD/MM/YYYY
export const formatDate = (
  date: Date,
  format: "dd/MM/yyyy" | "yyyyMMdd" = "dd/MM/yyyy"
) => {
  const year = date.getFullYear();
  let month = date.getMonth() + 1;
  let day = date.getDate();

  if (format === "dd/MM/yyyy") {
    return `${day < 10 ? "0" : ""}${day}/${
      month < 10 ? "0" : ""
    }${month}/${year}`;
  } else {
    return `${year}${month < 10 ? "0" : ""}${month}${
      day < 10 ? "0" : ""
    }${day}`;
  }
};

// Conevert date dd/MM/yyyy in yyyyMMdd
export const dateToNumber = (date?: string) => {
  return date?.split("/").reverse().join("");
};

export const dateToDisplayDate = (date?: string) => {
  // console.info(date);
  if (date === undefined || date === null) return "";

  let formattedDate = "";

  if (date.length === 8) {
    formattedDate = new Intl.DateTimeFormat("it-IT", {
      timeZone: "Europe/Rome",
    }).format(moment.utc(date).toDate());
  } else if (date.length === 14) {
    formattedDate = new Intl.DateTimeFormat("it-IT", {
      // dateStyle: "short",
      // timeStyle: "medium",
      year: "numeric",
      month: "numeric",
      day: "numeric",
      hour: "numeric",
      minute: "numeric",
      second: "numeric",
      timeZone: "Europe/Rome",
    }).format(moment.utc(date, "YYYYMMDDhhmmss").toDate());
  }

  return formattedDate;
};

export const stringDateToUtc = (date: string | undefined) => {
  if (date) return moment.utc(date).toDate();

  return undefined;
};

// Conevert date dd/MM/yyyy hh:mm:ss in yyyyMMddhhmmss
export const dateTimeToNumber = (dateTime?: string) => {
  const dateTimeSplitted = dateTime!.trim().split(" ");

  if (dateTimeSplitted.length === 2) {
    const date = dateTimeSplitted[0];
    const time = dateTimeSplitted[1];

    return `${date.split("/").reverse().join("")}${time.replaceAll(":", "")}`;
  }

  return "";
};

//From dd/MM/yyyy to MM/dd/yyyy
export const stringDateFormat = (date?: string) => {
  const dateArray = date?.split("/");
  const day = dateArray ? dateArray[0].toLocaleString() : "";
  const month = dateArray ? dateArray[1].toLocaleString() : "";
  const year = dateArray ? dateArray[2].toLocaleString() : "";
  return `${month}/${day}/${year}`;
};
